import React from 'react';
import { useTranslation } from '../App';

const Stats = () => {
  const t = useTranslation();
  const stats = [
    { number: '100', label: t.stats.clients },
    { number: '60', label: t.stats.projects },
    { number: '05', label: t.stats.awards },
    { number: '6', label: t.stats.experience }
  ];

  return (
    <section id="statistic" className="stats-main">
      <div className="container">
        <div className="flex flex-stat">
          {stats.map((stat, index) => (
            <div key={index} className="stats">
              <div className="counter">
                <h2 className="timer count-title">
                  <span className="count-number">{stat.number}</span>
                  <span className="c">+</span>
                </h2>
                <p className="stats-text">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;